import { deleteCookie, hasCookie  } from "cookies-next";
import { ActionTypes } from "../constants/action-types";

/*
Reducers for cart
*/
let sticky_cart;
let cart_list;
let open_mini_cart;
let open_qb_mini_cart;
if (typeof window !== "undefined") {
  // Perform localStorage action
  sticky_cart = localStorage.getItem("sticky_add_to_cart_click");
  if (!sticky_cart) {
    sticky_cart = true;
  } else {
    sticky_cart = sticky_cart;
  }
  // try catch not required but just in case JSON.parse fails, catch error and set to null for safety
  try {
    cart_list = sessionStorage.getItem("cart_list");
    cart_list = JSON.parse(cart_list);
    const cookiePresent = hasCookie('cookie_present')
    if(!cookiePresent) {
      cart_list = null
      //deleteCookie('checkoutId');
      sessionStorage.removeItem("cart_list");
    }
    if(cart_list?.error) {
      sessionStorage.removeItem("cart_list");
      cart_list = null
    }
  }
  catch(error) {
    cart_list = null;
  }
  open_mini_cart = false;
}

const initialState = {
  sticky_add_to_cart_click: sticky_cart,
  cart_list: cart_list,
  open_mini_cart: open_mini_cart,
  open_qb_mini_cart:open_qb_mini_cart,
  open_engrave_sidebar: false,
};



export const cartReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case ActionTypes.OPEN_STICKY_ADD_TO_CART:
      return {
        ...state,
        sticky_add_to_cart_click: payload,
      };
    case ActionTypes.CLOSE_STICKY_ADD_TO_CART:
      return {
        ...state,
        sticky_add_to_cart_click: payload,
      };
    case ActionTypes.ADD_TO_CART:
      return {
        ...state,
        cart_list: payload,
      };
    case ActionTypes.OPEN_MINI_CART:
      return {
        ...state,
        open_mini_cart: payload,
      };
    case ActionTypes.OPEN_QB_MINI_CART:
      return {
        ...state,
        open_qb_mini_cart: payload,
      };
    case ActionTypes.UPDATE_CART:
      return {
        ...state,
        cart_list: payload,
      };
    case ActionTypes.OPEN_ENGRAVE_SIDEBAR:
      return {
        ...state,
        open_engrave_sidebar: payload,
      };
    default:
      return state;
  }
};
